import React from 'react';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  width?: string;
}

const Modal: React.FC<ModalProps> = ({open, onClose, title, children, width = 'max-w-md'}) => {
  if (!open) {return null;}
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4"
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-xl w-full ${width} shadow-2xl relative max-h-[90vh] flex flex-col`}
        onClick={(e) => e.stopPropagation()}
        style={{maxWidth: '95vw'}}
      >
        {/* Close Button */}
        <button
          className="absolute left-4 top-4 w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-700 transition-colors cursor-pointer z-10 group"
          onClick={onClose}
          aria-label="إغلاق"
          type="button"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Header */}
        <div className="flex-shrink-0 p-6 pb-4 border-b border-gray-200">
          {title && <h2 className="text-xl font-bold text-right pr-12">{title}</h2>}
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
